var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ximg"},[_c('img',{class:['ximg-content', { 'hide-content': ! _vm.source, 'loading': ! _vm.hasLoaded }],attrs:{"src":_vm.source,"alt":_vm.ariaLabel}}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }